import { render, staticRenderFns } from "./ClientSatisfactionChart.vue?vue&type=template&id=2ccfe215&"
import script from "./ClientSatisfactionChart.vue?vue&type=script&lang=js&"
export * from "./ClientSatisfactionChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports